import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

const WrapperTextField = styled(TextField)`
  width: 100%;
  margin-top: ${(props) =>
    props.marginLabelTop !== undefined ? `${props.marginLabelTop}px` : '18px'};

  /* =========================
     LABEL
  ========================= */

  .MuiInputLabel-root {
    position: relative;
    transform: none !important;
    margin-bottom: 8px;

    color: #111827;

    font-family: ${(props) =>
      props.labelFontFamily ? props.labelFontFamily : 'Akkurat'};

    font-weight: ${(props) =>
      props.labelFontWeight ? props.labelFontWeight : '500'};

    font-style: normal;

    font-size: ${(props) =>
      props.labelFontSize ? props.labelFontSize : '16px'};

    line-height: ${(props) =>
      props.labelLineHeight ? props.labelLineHeight : '24px'};

    letter-spacing: ${(props) =>
      props.labelLetterSpacing ? props.labelLetterSpacing : '0px'};
  }

  .MuiInputLabel-root.Mui-focused {
    color: #111827;
  }

  .MuiInputLabel-shrink {
    transform: none !important;
  }

  /* =========================
     OUTLINED ROOT
  ========================= */

  .MuiOutlinedInput-root {
    border-radius: 16px;
    background: #ffffff;
    transition: all 0.2s ease;

    ${(props) =>
      !props.multiline &&
      `
      height: ${props.height ? `${props.height}px` : '48px'};
    `}

    /* DEFAULT BORDER */
    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) => (props.errorText ? '#EE3232' : '#D6D3D1')};
      border-width: 1px;
    }

    /* HOVER */
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #bfbab7;
    }

    /* FOCUS */
    &.Mui-focused fieldset {
      border-color: #111111 !important;
      border-width: 1px;
    }

    /* ERROR */
    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: #ee3232;
    }
  }

  /* =========================
     INPUT
  ========================= */

  .MuiOutlinedInput-input {
    padding: 0 16px;

    color: #111827;
    font-size: 15px;
    font-weight: 400;

    font-family: Poppins, sans-serif;

    &::placeholder {
      color: #9ca3af;
      opacity: 1;
      font-size: 14px;
    }

    ${(props) =>
      props.multiline &&
      `
      padding: 14px 16px;
      min-height: ${props.height ? `${props.height}px` : '100px'};
    `}
  }

  .MuiOutlinedInput-notchedOutline legend {
    display: none;
  }

  /* =========================
     ICONS
  ========================= */

  .MuiInputAdornment-root svg {
    font-size: 20px;
    color: #9ca3af;
  }

  /* =========================
     DISABLED
  ========================= */

  .Mui-disabled {
    background: #f9fafb;
    cursor: not-allowed;
  }

  /* =========================
     AUTOFILL FIX
  ========================= */

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #111827;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 14px;
  color: #b91c1c;
  line-height: 20px;
  font-weight: 400;
  font-family: Poppins, sans-serif;
  margin-top: 5px;
  letter-spacing: -0.08px;
`;

const WrapperHelperDiv = styled.div`
  color: #a2a2a2;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-family: Poppins, sans-serif;
`;

function LabelWithInput({ containerProps, min, max, ...props }) {
  const { ...restProps } = props;

  return (
    <FormControl fullWidth>
      <WrapperTextField
        id="standard-required"
        variant="outlined"
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: min || undefined,
          max: max || undefined,
          onClick: (e) => {
            if (props.type === 'date' || props.type === 'time') {
              try {
                e.target.showPicker();
              } catch (error) {
                e.target.focus();
              }
            }
          },
        }}
        InputProps={{
          notched: false,
          ...props.InputProps,
        }}
        multiline={props.multiline}
        {...restProps}
      />

      {props.errorText && <WrapperErrorDiv>{props.errorText}</WrapperErrorDiv>}

      {props.helperInfoPassword && (
        <WrapperHelperDiv>
          <div>
            <FormattedMessage id="register.helperText" />
          </div>
        </WrapperHelperDiv>
      )}
    </FormControl>
  );
}

LabelWithInput.defaultProps = {
  borderRadius: 4,
  fontSize: 16,
  textColor: '#1E1E1E',
};

export default LabelWithInput;
